import qs from 'qs'
import * as msgTypes from 'models/iFrame/msgTypes'
import { receiveIkeaTokens } from 'models/tokens/actions'
import { receiveCompiledComposition, setCompositionPreFetchLoading } from 'models/compositions/actions'
import { setBearerToken } from 'services'
import { setSpiderpigsToken } from 'services/spiderpigs'

export const setUpCompositionPreFetch = (store) => {
    const onCompositionPreFetchCallback = (data) => {
        const { composition, scene, furnitures } = data
        if (composition && scene && furnitures) {
            store.dispatch(receiveCompiledComposition(composition, scene, furnitures))
        } else {
            store.dispatch(setCompositionPreFetchLoading(false))
        }
    }
    const onCompositionPreFetchFailedCallback = () => {
        store.dispatch(setCompositionPreFetchLoading(false))
    }
    if (window.compositionPreFetchData) {
        // If we have the data, send it out
        onCompositionPreFetchCallback(window.compositionPreFetchData)
    } else if (window.compositionPreFetchLoading) {
        // If we're still loading, provide a callback
        window.onCompositionPreFetchCallback = onCompositionPreFetchCallback
        window.onCompositionPreFetchFailedCallback = onCompositionPreFetchFailedCallback
        // Let the application know we're loading something
        store.dispatch(setCompositionPreFetchLoading(true))
    }
}

export const setUpIFrameListener = (store) => {
    window.addEventListener('message', (message) => {
        if (
            MAGICWINDOW_ORIGIN !== '*' &&
            message.origin !== MAGICWINDOW_ORIGIN &&
            message.origin !== PARTNER_PORTAL_ORIGIN
        ) {
            return
        }
        switch (message.data.type) {
            case msgTypes.GET_TOKENS_RESPONSE:
                setBearerToken(message.data.tokens, message.data.isDev)
                setSpiderpigsToken(message.data.tokens)
                store.dispatch(receiveIkeaTokens(message.data.tokens))
                break
            default:
                break
        }
    })
}

export const getUrlContext = () => {
    /* eslint-disable i18next/no-literal-string */

    const params = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    const isMagicWindow = Object.prototype.hasOwnProperty.call(params, 'magicWindow')

    const isKiosk = window.location.href.indexOf('h22') > -1
    // TODO (Anu): remove / this is for debugging purposes
    // const isKiosk = true

    return {
        isMagicWindow,
        hideDashboard: isMagicWindow || isKiosk || Object.prototype.hasOwnProperty.call(params, 'hideDashboard'),
        isKiosk,
    }
}
